import { useEffect, useRef } from 'react'
import { loadAvatarCached } from 'helpers/avatarCache'
import { path } from 'utils/constants/path'
import { AVATAR_TYPE } from './constants'
import { Avatar } from './styled'

export const AvatarSpecial = ({
  src,
  isApi = false,
  size = '',
  alt = '',
  type = AVATAR_TYPE.USER,
  onLoad,
  onLoadError,
}) => {
  const imgRef = useRef(null)
  const { defaultAvatarPath } = path

  const fallback = type === AVATAR_TYPE.USER && defaultAvatarPath

  useEffect(() => {
    const img = imgRef.current
    if (!img) return

    img.setAttribute('referrerpolicy', 'no-referrer')

    if (!isApi || !src) {
      if (fallback) {
        img.src = fallback
      } else {
        img.removeAttribute('src')
        onLoadError()
      }
      return
    }

    let cancelled = false

    const applyAvatar = async () => {
      const cachedUrl = await loadAvatarCached(src)

      if (cancelled || !imgRef.current) return

      if (cachedUrl) {
        imgRef.current.src = cachedUrl
      } else if (fallback) {
        imgRef.current.src = fallback
      } else {
        imgRef.current.removeAttribute('src')
        onLoadError()
      }
    }

    applyAvatar()

    return () => {
      cancelled = true
    }
  }, [src, isApi, fallback, onLoadError])

  return (
    <Avatar
      ref={imgRef}
      alt={alt}
      $size={size}
      onLoad={onLoad}
      onError={() => {
        if (!imgRef.current) return

        if (fallback) {
          imgRef.current.src = fallback
        } else {
          imgRef.current.removeAttribute('src')
          onLoadError()
        }
      }}
    />
  )
}
